export default __webpack_public_path__ + "static/media/Midranger - Apocalypse [NCS Release].9cc2c231.mp3";